import type { MouseEventHandler } from 'react';
import { IconButton } from '@ksyos/design-system';

export interface IBackButtonProps {
    disabled?: boolean;
    goBackFunction: MouseEventHandler<HTMLButtonElement>;
}

export function BackButton(props: IBackButtonProps) {
    return (
        <IconButton
            disabled={props.disabled}
            icon="caret-left-big"
            labelText="Ga terug"
            onClick={props.goBackFunction}
            size="small"
        />
    );
}
